function showMessageBox(type, message, callback=()=>{}) {
    var boxType = 'alert-' + type;
    var content = '';
    var messageBox = '<div class="alert ' + boxType + ' fade in">' + message + content + '</div>';
    $('div.alert-box').html(messageBox);
    setTimeout(function() {
        $('div.alert-box').html('');
        callback();
    }, 5000);
}